import { useState, useEffect } from 'react';
import { SEARCH_DELAY } from '../constants/defaultParameters';

export default function useDebounce(value, delay = SEARCH_DELAY) {
    const [debouncedValue, setDebouncedValue] = useState(value);

    useEffect(
        () => {
            const handler = setTimeout(() => {
                setDebouncedValue(value);
            }, delay);

            return () => {
                clearTimeout(handler);
            };
        },
        [value, delay]
    );

    return debouncedValue;
}